<template>
  <SoAlert
    type="error"
    title="Unable to load meterpoint details"
    :text="`${meterpoint.meterpointType} ${meterpoint.identifier} is on this account, but its details couldn't be loaded from Junifer. Try again later.`"
    data-testid="unavailable-meterpoint"
  />
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoAlert from "@/components/SoAlert.vue"
  import { IMeterpoint } from "@/models/meterpoint/meterpoint.types"

  export default defineComponent({
    components: { SoAlert },
    props: {
      meterpoint: {
        type: Object as PropType<Pick<IMeterpoint, "meterpointType" | "identifier">>,
        required: true,
      },
    },
  })
</script>
